import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { Model } from "@ckeditor/ckeditor5-engine";
import { routes } from "src/constants/routes";
import { linkArtefactIconGreenSvg } from "src/constants/svg/link-artefact-iconSVG";
import { ArtefactType } from "src/models/models.model";

@Component({
  selector: "app-model-card",
  templateUrl: "./model-card.component.html",
  styleUrls: ["./model-card.component.scss"],
})
export class ModelCardComponent {
  readonly artefactType = ArtefactType;
  readonly routes = routes;
  readonly linkArtefactIconGreenSvg = linkArtefactIconGreenSvg;
  @Input() modelItem!: any;
  @Input() linkedArtefact: boolean = false;

  constructor(private router: Router) {}

  onViewModelClick(id: any) {
    this.router.navigate([`/admin/models/details/${id}`]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
